/** A referential catalogue: no tenant, no parameter. */
class FetchAiTranscriptionDeliveryModes {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchAiTranscriptionDeliveryModes;
